<template>
  <p>Esto es Track Paquetes.</p>
</template>

<script>
export default {

}
</script>

<style>

</style>